import { Color } from '@videosmart/player-template';

export const colorToRgbString = (color: Color): string => {
  return `rgb(${color.red},${color.green},${color.blue})`;
}